<!-- <mat-dialog-content> -->

<div class="mat-modal-container">
  <div *ngIf="closebtn"><button class="close-btn" (click)="dialog.closeAll()" mat-raised-button mat-icon-button><mat-icon>close</mat-icon></button></div>

  <div class="success-modal" *ngIf="isSuccess == true && !successPopup">
    <app-lead-success></app-lead-success>
  </div>

<div *ngIf="isSuccess == false">
  <div *ngIf="header">
    <div *ngIf="!isMobile">
      <img loading="lazy" data-src="/assets/images/homepage/success-img.svg" class="sucess-img" alt="success image" />
      <span class="hello">Hello!</span>
      <h1 class="hello-head">
        Would you like to discuss something with Team Ketto?<br/>
        Drop in your contact details so we can get in touch with you.
      </h1>
    </div>
    <div *ngIf="isMobile" class="mobile-whatsapp">
      <a target="_blank" [href]="'https://api.whatsapp.com/send?phone=91' + variablesService.contactUsMobNumber" class="whatsapp-bg"
      mat-stroked-button><i class="icon-whatsapp" (click)="eventListner($event)"></i>Chat with us on Whatsapp</a>
      <div id="or-separator">OR</div>
      <p>Drop in your query so we’ll get back to you.</p>
    </div>
  </div>
  <form class="talk-to-us-form" [formGroup]="leadForm" #leadFormRef="ngForm" (ngSubmit)="verifyUserOTP()">
    <app-input [group]="leadForm" [control]="name" [placeHolder]="formInfo.name.placeholder" [errorMessage]="formInfo.name.error" [info]="false" icon="icon-user"></app-input>
    <app-input *ngIf="showEmail" [group]="leadForm" [control]="email" [placeHolder]="formInfo.email.placeholder" [errorMessage]="formInfo.email.error" [info]="false" icon="icon-mail"></app-input>
    <div class="mt-1 pos-rel">
      <app-intl-input class="intl-input-container pos-rel" [group]="leadForm" [control]="mobile" [hideSuffixIcon]="true" [checkCountry]="checkCountry"></app-intl-input>
      <span class="get-otp" id="getOtp" [ngClass]="{ 'disable-click': isLoadingForOtp }" *ngIf="mobile.valid" matSuffix (click)="isLoadingForOtp? $event.preventDefault(): recaptchaVerification()">
        <span *ngIf="!isLoadingForOtp">
          {{otpText}}
        </span>
        <span *ngIf="isLoadingForOtp" class="disable-click">
          Sending
        </span>
      </span>
    </div>
    <div class="mt-1 pos-rel" *ngIf="showOtpInput" @slideInOut>
      <app-input
        [group]="otpForm"
        [control]="otp"
        [placeHolder]="formInfo.otp.placeholder"
        [info]="false"
        inputType="text"
        [errorMessage]="formInfo.otp?.['required']">
      </app-input>
    </div>
    <mat-form-field [hidden]="hideFields?.typeOfQuery">
      <mat-label>Type of query</mat-label>
      <mat-select name="query_type" [formControl]="query_type" (selectionChange)="onQueryTypeSelection()">
        <mat-option *ngFor="let query of leadQueryTypesData" [value]="query.value">{{ query.text }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field [hidden]="hideFields?.cause" *ngIf="query_type.value === 'want_to_raise_funds'">
      <mat-label>Please choose your purpose of raising funds</mat-label>
      <mat-select formControlName="cause" (selectionChange)="onMedicalSelection()">
        <mat-option *ngFor="let cause of frCauses" [value]="cause.value">
          {{ cause.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="fundusedfor && cause?.value === 'medical' && query_type.value === 'want_to_raise_funds'">
      <mat-label>What will the funds be used for?</mat-label>
      <mat-select name="fundusedfor" formControlName="fund">
        <mat-option *ngFor="let fund of fundsUsed" [value]="fund.value">{{ fund.text }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="hospitalstatus && cause?.value === 'medical' && query_type.value === 'want_to_raise_funds'">
        <mat-label>Hospitalisation status</mat-label>
        <mat-select name="hospitalstatus" formControlName="status">
          <mat-option *ngFor="let status of hospitalStatusData" [value]="status.value">{{ status.text }}</mat-option>
        </mat-select>
      </mat-form-field>
    <mat-form-field *ngIf="query">
      <textarea matInput placeholder="Ask a question" [formControl]="query" name="askquest" class="ask-textarea"></textarea>
      <mat-error *ngIf="query.hasError('required') && query.touched">Field required</mat-error>
      <mat-error *ngIf="query.hasError('maxlength') && query.touched">{{formInfo.query.error.maxlength}}</mat-error>
    </mat-form-field>
      <input type="hidden" name="mail_to" class="form_input">
      <input type="hidden" name="subject" class="form_input">
      <!-- Campaign counts -->
      <div *ngIf="campaignCount" class="campaign-count">{{campaignCount}} People started a fundraiser in last 2 days</div>
      <!-- Start A Fundraiser Button -->
      <div *ngIf="isMedicalFinanceLoans">
        2 Lakh+ people have raised more than 100 Cr through Medical Crowdfunding in last 3 years
      </div>
      <button *ngIf="showSacBtn" mat-raised-button type="button" (click)="gotoSac()" class="submit-btn shadow-btn" [disabled]="isLoading">
        START A FUNDRAISER
      </button>
    <div *ngIf="!hideConnectBtn" class="btn-holder">
      <div *ngIf="isLoadingForOtp">
        <app-captcha-input #captchaRef [control]="captcha" type="dialog" size="invisible" [execute]="true"></app-captcha-input>
        <app-captcha></app-captcha>
      </div>

      <!-- Submit button -->
      <button mat-raised-button type="submit" class="submit-btn" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{label}}</span>
        <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
      <button mat-raised-button class="submit-btn whatsapp-btn" type="button" *ngIf="data?.showWhatsApp" (click)="connectOnWhatsapp()">
        <i class="icon-whatsapp"></i>Connect on Whatsapp
      </button>
    </div>
  </form>
</div>
</div>
<!-- </mat-dialog-content> -->
<ng-template #successPopupRef>
  <div class="mat-modal-container">
    <button class="close-btn" (click)="dialog.closeAll()" mat-raised-button mat-icon-button><mat-icon>close</mat-icon></button>
    <div class="success-modal">
      <app-lead-success></app-lead-success>
    </div>
  </div>
</ng-template>
